
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c1.292 0 2.394.844 2.813 2h7.188v2h-1.406l.281.5 4 7 .125.25V17c0 2.75-2.25 5-5 5s-5-2.25-5-5v-.25l.125-.25 4-7 .281-.5h-4.594A3.033 3.033 0 0117 10.813v13.188h4v2H11v-2h4V10.813A3.023 3.023 0 0113.187 9H8.593l.281.5 4 7 .125.25V17c0 2.75-2.251 5-5 5s-5-2.25-5-5v-.25l.125-.25 4-7 .281-.5H5.999V7h7.188c.418-1.156 1.521-2 2.813-2zm0 2c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1zm-8 5.031L5.719 16h4.563zm16 0L21.719 16h4.563zM5.25 18c.402 1.161 1.444 2 2.75 2s2.348-.839 2.75-2h-5.5zm16 0c.402 1.161 1.444 2 2.75 2s2.348-.839 2.75-2h-5.5z"}})])
          )
        }
      }
    